export const WP_REST_HOST = ''; // see proxy field in package.json
export const WP_REST_URL_EVENTS = `${WP_REST_HOST}/wp-json/caedm/v1/events`;
export const WP_REST_URL_EVENT_TYPES = `${WP_REST_HOST}/wp-json/wp/v2/event_type`;
export const WP_REST_URL_PARISHES = `${WP_REST_HOST}/wp-json/caedm/v1/parishes`;
export const WP_REST_URL_PRIESTS = `${WP_REST_HOST}/wp-json/caedm/v1/priests`;
export const WP_REST_URL_PARISH = `${WP_REST_HOST}/wp-json/caedm/v1/parish`;
export const WP_REST_URL_PARISHES_PAGE = `${WP_REST_HOST}/wp-json/wp/v2/pages?slug=parishes`;
export const WP_REST_URL_MULTI_PARISH = `${WP_REST_HOST}/wp-json/caedm/v1/multi-parish`;
export const WP_REST_URL_PARISH_FILTERABLES = `${WP_REST_URL_PARISH}/filterables`;
export const WP_REST_URL_PARISHES_MASS = `${WP_REST_HOST}/wp-json/caedm/v1/parishes_mass`;